import React, { FC } from 'react';

import {
  ModalFullScreen,
  ModalFullScreenHeader,
  ModalFullScreenContent,
} from '../../../../../../components/modal';
import { Container, Row, Column } from '../../../../../../components/grid/Grid';

import { useLinkedLegislationsFetcher } from '../../hooks/useLinkedLegislationsFetcher';

import styles from './linked_texts_modal.module.scss';
import { HyperlinkRestrictedBaseModal } from '../../../../../../components/HyperlinkRestrictedBaseModal';
import { AbstractedContent } from '../abstracted-content/AbstractedContent';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  articlesLength: number;
  articleId: string;
  articleTitle: string;
};

export const LinkedTextsModal: FC<Props> = ({
  isOpen,
  onRequestClose,
  articlesLength,
  articleId,
  articleTitle,
}) => {
  const quotedByLegislations = useLinkedLegislationsFetcher(
    articleId,
    'quoted_by',
    null,
    true,
  );

  return (
    <ModalFullScreen isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalFullScreenHeader onClose={onRequestClose}>
        {articleTitle}
      </ModalFullScreenHeader>
      <ModalFullScreenContent>
        <Container className={styles.container}>
          <Row>
            <Column>
              <h2 className={styles.title}>{articlesLength} articles liés</h2>
            </Column>
          </Row>
          {quotedByLegislations?.quotedBy.items.map(
            ({
              title,
              content,
              articleId: quotedByArticleId,
              isLinked,
              url,
            }) => {
              return (
                <Row key={quotedByArticleId}>
                  <Column className={styles.article} medium={8}>
                    {isLinked && quotedByArticleId ? (
                      <HyperlinkRestrictedBaseModal
                        className={styles.link}
                        url={url}
                        source="linked_law_page"
                      >
                        {title}
                      </HyperlinkRestrictedBaseModal>
                    ) : (
                      <span className={styles.deadLink}>{title}</span>
                    )}
                    {content && (
                      <p className={styles.content}>
                        <AbstractedContent
                          content={content}
                          url={url}
                          source="linked_law_page"
                        />
                      </p>
                    )}
                  </Column>
                </Row>
              );
            },
          )}
        </Container>
      </ModalFullScreenContent>
    </ModalFullScreen>
  );
};
